import React from 'react'
import { Divider as ChakraDivider, DividerProps } from '@chakra-ui/react'

export const Divider = (props: DividerProps) => {
  return <ChakraDivider borderColor="light.1" {...props} />
}
